import styled from 'react-emotion';

export const Container = styled('div')`
  outline: none;
`;

export const EditorWrapper = styled('div')`
  padding: 12px 0;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden; // prevents empty editor placeholder from overflowing
  font-size: 14px;
  line-height: 1.4;
  ${({ readOnly }) => (readOnly ? 'opacity: 0.5;' : '')};
`;
